import { useState, useEffect } from 'react';
import { checkPastDate } from '../user';
const authEvents = ['cas-js:renew', 'cas-js:user', 'storage'];
interface ICasDetail {
  expires_at: number;
}
interface ICasEvent extends Event {
  detail?: ICasDetail;
}

/**
 * Hook to listen for changes in the user's authentication state
 * @returns {string} - 'logged' if the user is logged in, 'not-logged' if the user is not logged in, 'expired' if the user's session has expired
 */
const useAuthState = () => {
  function checkAuthState(e?: ICasEvent) {
    const newState = e?.detail;
    const currState = localStorage.getItem('cas-js:user');
    if (!currState && !newState) return 'not-logged';
    const parsedData = JSON.parse(currState || '{}');
    const expires_at = newState?.expires_at || parsedData?.expires_at;
    if (checkPastDate(expires_at)) {
      return 'expired';
    }
    return 'logged';
  }

  const [authState, setAuthState] = useState(checkAuthState());

  useEffect(() => {
    const handleAuthChange = e => {
      setAuthState(checkAuthState(e));
    };

    authEvents.forEach(event => window.addEventListener(event, handleAuthChange));

    return () => {
      window.removeEventListener('storage', handleAuthChange);
      authEvents.forEach(event => window.removeEventListener(event, handleAuthChange));
    };
  }, []);

  return authState;
};

export default useAuthState;
